export const GET_HOME_FEED_REQUEST = 'GET_HOME_FEED_REQUEST';
export const GET_HOME_FEED_SUCCESS = 'GET_HOME_FEED_SUCCESS';
export const GET_HOME_FEED_FAILURE = 'GET_HOME_FEED_REQUEST';
